<section class="container mt-4">
  <h1 class="subscription-management-header text-muted">Subscriptions
    <mat-icon class="text-muted">subscriptions</mat-icon>
  </h1>

  <mat-divider class="mb-3"></mat-divider>

  <div class="flex-row">

    @for (sub of subscriptions; track sub) {
      <mat-card style="border-radius: 4px;" class="card ml-2">
        <mat-card-title class="text-muted ml-3 mt-2">
          Service Plan
          
          <div class="edit-subs-btn mr-4" mat-card-avatar>
            @if (!sub.subscriptionCancelAtPeriodEnd) {
              <mat-icon class="clickable red-icon" (click)="openCancelSubDialog(sub)" matTooltip="Cancel Subscription">close</mat-icon>
            }
          </div>
        </mat-card-title>
        <mat-card-subtitle class="ml-3 mb-2 subscription-management-text">{{sub.serviceTypeName}}</mat-card-subtitle>
        @if (sub.subscriptionCancelAtPeriodEnd) {
          <mat-card-subtitle class="warn-font ml-3 mb-2">Subscription Canceled</mat-card-subtitle>
        }
        <mat-card-subtitle class="ml-3 subscription-management-text">Subscription paid until {{sub.subscriptionPaidTill | date: 'shortDate'}}</mat-card-subtitle>
        <mat-divider class="mt-2  ml-3 mr-3"></mat-divider>
        <div>
          <mat-card-content class="mb-3">
            <p> Subscription purchased {{sub.subscriptionCreateDateUTC | date: 'shortDate'}}</p>
            <p>{{sub.servicePlanDescription}}</p>
            <p>{{sub.appointmentLocation}}</p>
            <p>${{sub.servicePlanRate.toFixed(2)}}</p>
          </mat-card-content>
        </div>
        <mat-divider class="mb-2  ml-3 mr-3"></mat-divider>
        <mat-card-title class="text-muted ml-3 subscription-management-header">Contact Info</mat-card-title>
        <div>
          <mat-card-content>
            <p>{{sub.serviceProviderBusinessName}}</p>
            <p>{{sub.serviceProviderName}}</p>
            <p>{{sub.serviceProviderCity + "," + sub.serviceProviderState}}</p>
            <p>{{sub.serviceProviderEmail}}</p>
            <p>{{sub.serviceProviderPhone}}</p>
          </mat-card-content>
        </div>
      </mat-card>
    }
  </div>
</section>